import {
  apiPath,
  type DataFeed,
  type DataFeedPreview,
  type DataFeedPreviewRequest,
  DataFeedPreviewSchema,
  DataFeedSchema,
  type DataFeedSummary,
  DataFeedSummarySchema,
  type UpsertDataFeedRequestInput,
} from '@codot/contracts';
import { request } from './http';

/** Phase 16 Step 15c: data feeds. */
export const dataFeedsApi = {
  list: (): Promise<DataFeedSummary[]> => request('GET', apiPath('dataFeeds'), DataFeedSummarySchema.array()),
  get: (feedId: string): Promise<DataFeed> => request('GET', apiPath('dataFeed', { feedId }), DataFeedSchema),
  create: (body: UpsertDataFeedRequestInput): Promise<DataFeed> => request('POST', apiPath('dataFeeds'), DataFeedSchema, body),
  update: (feedId: string, body: UpsertDataFeedRequestInput): Promise<DataFeed> => request('PUT', apiPath('dataFeed', { feedId }), DataFeedSchema, body),
  remove: (feedId: string): Promise<unknown> => request('DELETE', apiPath('dataFeed', { feedId }), null),
  sync: (feedId: string): Promise<DataFeed> => request('POST', apiPath('dataFeedSync', { feedId }), DataFeedSchema),
  approve: (feedId: string): Promise<DataFeed> => request('POST', apiPath('dataFeedApprove', { feedId }), DataFeedSchema),
  reject: (feedId: string): Promise<DataFeed> => request('POST', apiPath('dataFeedReject', { feedId }), DataFeedSchema),
  preview: (body: DataFeedPreviewRequest): Promise<DataFeedPreview> => request('POST', apiPath('dataFeedPreview'), DataFeedPreviewSchema, body),
};
